<template>
  <div class="friend-list-container">
    <div class="title">
      Our top 3 winners
    </div>
    <div class="friend-list">
      <p>
        Congratulations to our winners:
      </p>
      <p class="winners">
        <span v-for="(name, i) in top3Winners" :key="name">
          <span class="winner"> {{ name }}</span
          >{{ i === top3Winners.length - 1 ? "" : "," }}
        </span>
      </p>
    </div>

    <div class="notify-next-event">
      <p>
        Would you like for us to notify <br />
        you of our next event?
      </p>
      <a
        href="mailto:team@covve.com?subject=Notify me of your next Snake event!"
        class="img-a-button"
        ><img src="@/assets/btn-yes.png" alt="yes!"
      /></a>
    </div>
  </div>
</template>

<script>
import { db } from "@/main.js";
import firebase from "firebase";

export default {
  data() {
    return {
      top3Winners: []
    };
  },

  methods: {
    fetchTop3() {
      db.collection("Users")
        .orderBy("totalScore", "desc")
        .limit(3)
        .get()
        .then(
          snap => (this.top3Winners = snap.docs.map(d => d.data().displayName))
        );
    }
  },
  mounted() {
    this.fetchTop3();
  }
};
</script>

<style lang="scss" scoped>
.friend-list-container {
  text-align: center;
  max-width: 450px;
  .title {
    margin-bottom: 40px;
  }
  .friend-list {
    font-size: 0.725rem;
    max-width: 710px;
    p {
      margin: 20px;
    }
    .winners {
      margin-top: -10px;
      font-size: 1rem;
      .winner {
        color: $accent-color;
      }
    }
  }

  .notify-next-event {
    margin-top: 30px;
    padding: 15px 30px;
    font-size: 0.725rem;
    background: #231b4d;
    border-radius: 20px;
    p {
      margin: 10px 0 20px 0;
    }
  }
}
</style>